/**
 * Help topic access for the Support Launcher — role-filtered search and
 * contextual topics over src/data/helpContent.ts (2,000+ lines of written
 * help that sat unmounted until the launcher's Help tab).
 */
import {
  getContextualHelp,
  searchHelpTopics,
  helpTopics,
  type HelpTopic,
} from '../../data/helpContent';
import type { UserRole } from '../../types/user.types';

function visibleTo(topic: HelpTopic, role: UserRole | string | undefined): boolean {
  if (!topic.roles || topic.roles.length === 0) return true;
  return topic.roles.includes(role as UserRole);
}

export function searchHelp(queryText: string, role?: UserRole | string): HelpTopic[] {
  return searchHelpTopics(queryText)
    .filter((t) => visibleTo(t, role))
    .slice(0, 12);
}

export function contextualHelp(pathname: string, role?: UserRole | string): HelpTopic[] {
  return getContextualHelp(pathname)
    .filter((t) => visibleTo(t, role))
    .slice(0, 6);
}

export function popularHelp(role?: UserRole | string): HelpTopic[] {
  return helpTopics.filter((t) => visibleTo(t, role)).slice(0, 8);
}
